/* eslint-disable no-redeclare */
import Vue from 'vue'
import $ from 'jquery'
import moment from 'moment-timezone'

// var project

export default class Common {
    constructor() {
        // project = _vm
    }

    // 處理電話號碼
    getPhoneCode (_countryCode = '+886', _regPhone = '') {
        if (_countryCode === '+886') {
            if (_regPhone.substr(0, 1) === '0') {
                return _countryCode + _regPhone.substr(1)
            } else {
                return _countryCode + _regPhone
            }
        } else {
            return _countryCode + _regPhone
        }
    }

    // 格式化數字
    formatNumber (num = 0, _format = 2) {
        if (!num) {
            return 0.00
        } else {
            Number.prototype.numberFormat = function (c, d, t) {
                var n = this,
                    c = isNaN(c = Math.abs(c)) ? 2 : c,
                    d = d == undefined ? "." : d,
                    t = t == undefined ? "," : t,
                    s = n < 0 ? "-" : "",
                    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                    j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
            }

            var tempNumber = parseFloat(num)
            var number = tempNumber.numberFormat(_format, '.', ',')
            // console.log('=> formatNumber: ' + num + ' to ' + number)
            return number
        }
    }

    //- 設定 Storage 資料
    setData (_key = '', _val = '') {
        console.log("=> 寫入 LocalStorage Data: " + _key);
        Vue.localStorage.set(_key, _val)
        return true
    }

    //- 取得 Storage 資料
    getData (_key = '') {
        console.log("=> 取得 LocalStorage Data: " + _key);
        return Vue.localStorage.get(_key)
    }

    // 取得目前時間
    getNowTime (_type = 'datetime', _target = false) {
        // 取得日期
        var today
        if (_target) {
            // 處理數值型態的時間
            if (Number.isInteger(_target)) {
                today = new Date(_target * 1000)
            }
            // 處理文字型態的時間
            else {
                today = moment(_target, 'YYYY-MM-DD HH:mm:ss').toDate();
            }
        } else {
            today = new Date()
        }

        var weeks = ['日', '一', '二', '三', '四', '五', '六']

        var timestamp = Math.floor(today / 1000)
        var nowYear = today.getFullYear()
        var nowMonth = (today.getMonth() + 1)
        var nowDate = today.getDate()
        var nowHour = today.getHours()
        var nowMin = today.getMinutes()
        var nowSec = today.getSeconds()
        var nowWeek = weeks[today.getDay()]

        // 2020-03-03
        if (_type === 'date') {
            return this.paddingLeft(nowYear.toString(), 2) + '-' + this.paddingLeft(nowMonth.toString(), 2) + '-' + this.paddingLeft(nowDate.toString(), 2)
        }

        if (_type === 'date-day') {
            return this.paddingLeft(nowDate.toString(), 2)
        }

        // Week 3
        if (_type === 'week') {
            return today.getDay()
        }

        // 04-03(三)
        if (_type === '2date') {
            return this.paddingLeft(nowMonth.toString(), 2) + '/' + this.paddingLeft(nowDate.toString(), 2) + '(' + nowWeek + ')'
        }

        // 04/03
        if (_type === '4date') {
            return this.paddingLeft(nowMonth.toString(), 2) + '/' + this.paddingLeft(nowDate.toString(), 2)
        }

        // 04月03日
        if (_type === '3date') {
            return this.paddingLeft(nowMonth.toString(), 2) + '月' + this.paddingLeft(nowDate.toString(), 2) + '日'
        }

        // 2020
        if (_type === 'year') {
            return nowYear
        }

        // 01
        if (_type === 'month') {
            return this.paddingLeft(nowMonth.toString(), 2)
        }

        // 2020-03-03 15:15:15
        if (_type === 'datetime') {
            return nowYear + '-'
                + this.paddingLeft(nowMonth.toString(), 2) + '-'
                + this.paddingLeft(nowDate.toString(), 2) + ' '
                + this.paddingLeft(nowHour.toString(), 2) + ':'
                + this.paddingLeft(nowMin.toString(), 2) + ':'
                + this.paddingLeft(nowSec.toString(), 2)
        }

        // 15:15
        if (_type === 'time') {
            return this.paddingLeft(nowHour.toString(), 2) + ':' + this.paddingLeft(nowMin.toString(), 2)
        }

        if (_type === 'timestamp') {
            return timestamp
        }

        if (_type === 'today') {
            return today
        }
    }

    // 計算兩個時間的時間差
    calculateHourDifference (startTime, endTime) {
        // 将输入的时间字符串转换为Date对象
        const startDate = this.getNowTime('today', startTime)
        const endDate = this.getNowTime('today', endTime)

        // 计算时间差（单位为毫秒）
        const timeDifference = endDate - startDate;

        // 将毫秒转换为小时
        const hoursDifference = timeDifference / (1000 * 60 * 60);

        return hoursDifference;
    }

    // 計算兩個時間的日期差
    calculateDayDifference (startDate, endDate) {
        // 将输入的日期字符串转换为Date对象
        const date1 = this.getNowTime('today', startDate)
        const date2 = this.getNowTime('today', endDate)

        // 计算日期差（单位为毫秒）
        const timeDifference = date2 - date1;

        // 将毫秒转换为天数
        const dayDifference = timeDifference / (1000 * 60 * 60 * 24);

        return Math.ceil(dayDifference);
    }

    // 人性化時間
    beautifyTime (_time) {
        let timestamp = this.getNowTime('timestamp', _time)
        var mistiming = Math.round(new Date() / 1000) - timestamp;
        var postfix = mistiming > 0 ? '前' : '後'
        mistiming = Math.abs(mistiming)
        var arrr = ['年', '個月', '星期', '天', '小時', '分鐘', '秒'];
        var arrn = [31536000, 2592000, 604800, 86400, 3600, 60, 1];

        for (var i = 0; i < 7; i++) {
            var inm = Math.floor(mistiming / arrn[i])
            if (inm != 0) {
                return inm + '  ' + arrr[i] + postfix
            }
        }
    }

    // 補0
    paddingLeft (str, lenght) {
        if (str.length >= lenght) { return str } else { return this.paddingLeft('0' + str, lenght) }
    }

    // 返回頁面最頂端
    goToPageTop () {
        $('*').animate({ scrollTop: 0 }, 'slow');
    }

    // 瞬間返回最頂端
    goToPageTopFast () {
        setTimeout(() => {
            $('*').animate({ scrollTop: 0 }, 0);
        }, 500)
    }

    // 隨機產生字串
    generAtorMoreInt (_len) {
        let password = ''
        let word = '0123456789'
        let len = word.length

        for (let index = 0; index < _len; index++) {
            password += word[Math.floor(Math.random() * len)]
        }

        return password
    }

    // 隨機產生字串
    generAtorMoreEng (_len) {
        let password = ''
        let word = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
        let len = word.length

        for (let index = 0; index < _len; index++) {
            password += word[Math.floor(Math.random() * len)]
        }

        return password
    }

    // 驗證 Email 格式
    validateEmail (_email) {
        // eslint-disable-next-line no-useless-escape
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(_email)) {
            return true
        }

        return false
    }

    // 取得目前所在時區
    getCurrentLocation () {
        let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return timeZone
    }
}